import { createDirectStore } from 'direct-vuex';
import VuexPersistence from 'vuex-persist';
import { CollectionNamespaces } from '@/enums';
import {
  authModule,
  appDefaultsModule,
  bidsModule,
  clientsModule,
  groupModule,
  materialsModule,
  trucksModule,
  usersModule,
  vendorsModule,
  internalModule,
  userSettingsModule
} from '@/store/modules';
// import { createLogger } from 'vuex';

interface RootState {
  auth: typeof authModule;
  internal: typeof internalModule;
  [CollectionNamespaces.Bids]: typeof bidsModule;
  [CollectionNamespaces.Clients]: typeof clientsModule;
  [CollectionNamespaces.Groups]: typeof groupModule;
  [CollectionNamespaces.Materials]: typeof materialsModule;
  [CollectionNamespaces.Trucks]: typeof trucksModule;
  [CollectionNamespaces.Users]: typeof usersModule;
  [CollectionNamespaces.Vendors]: typeof vendorsModule;
  [CollectionNamespaces.UserSettings]: typeof userSettingsModule;
}

const vuexLocal = new VuexPersistence<RootState>({
  storage: window.localStorage,
  reducer: state => ({
    auth: state.auth,
    [CollectionNamespaces.Groups]: state.groups
  })
});

const { store, rootActionContext, moduleActionContext, rootGetterContext, moduleGetterContext } = createDirectStore({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    auth: authModule,
    internal: internalModule,
    [CollectionNamespaces.AppDefaults]: appDefaultsModule,
    [CollectionNamespaces.Bids]: bidsModule,
    [CollectionNamespaces.Clients]: clientsModule,
    [CollectionNamespaces.Groups]: groupModule,
    [CollectionNamespaces.Materials]: materialsModule,
    [CollectionNamespaces.Trucks]: trucksModule,
    [CollectionNamespaces.Users]: usersModule,
    [CollectionNamespaces.Vendors]: vendorsModule,
    [CollectionNamespaces.UserSettings]: userSettingsModule
  },
  plugins: [vuexLocal.plugin /* , ...(process.env.NODE_ENV !== 'production' ? [createLogger()] : []) */]
});

export default store;
export const useStore = () => store;
export { rootActionContext, moduleActionContext, rootGetterContext, moduleGetterContext };
